import { Alert } from 'reactstrap'
import React from 'react'
import PageHeader from '../common/PageHeader'
import BanksList from './BanksList'
import CondominiumBankList from './CondominiumBankList'
import { useParams } from 'react-router'
import withRedirect from '../../helpers/hoc/withRedirect';

import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import SupportLink from '../root/support/components/SupportLink'

const Bank = () => {

    const { id } = useParams();
    const { all } = useParams();
    const { selectedCondominium } = useSelector(state => state.condominium);
    const { role } = useSelector(state => state.auth.user);

    return (
        <>
            <PageHeader title="Bancos" titleTag="h2" className="mb-3" col={{ lg: 9 }}
                description={role === 'manager' ? "Gestiona cada uno de tus bancos." : 'Bancos de tu condominio'}>
                <SupportLink />
            </PageHeader>

            {role === 'manager' && all && <BanksList showPagination={true} />}
            {role === 'manager' && id && <CondominiumBankList condominiumId={id} showPagination={true} />}
            {role === 'manager' && id && selectedCondominium && <CondominiumBankList condominiumId={id} showPagination={true} />}
            {role === 'manager' && selectedCondominium && !id && !all && <CondominiumBankList condominiumId={selectedCondominium} showPagination={true} />}
            {role === 'property' && <CondominiumBankList condominiumId={selectedCondominium} showPagination={true} />}
        </>
    )
}

export default withRedirect(Bank);